module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_detail') === -1) ? _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "md": 6,
      "lg": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "订单号",
      "clearable": "",
      "size": "mini"
    },
    on: {
      "clear": _vm.keywordsSearch
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.keywordsSearch.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.order_id),
      callback: function($$v) {
        _vm.order_id = $$v
      },
      expression: "order_id"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.keywordsSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 6,
      "lg": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "货号(多货号用英文,隔开，如：1234,5678)",
      "clearable": "",
      "size": "mini"
    },
    on: {
      "clear": _vm.keywordsSearch
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.keywordsSearch.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.sku_bn),
      callback: function($$v) {
        _vm.sku_bn = $$v
      },
      expression: "sku_bn"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.keywordsSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 6,
      "lg": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "推广者账号",
      "clearable": "",
      "size": "mini"
    },
    on: {
      "clear": _vm.keywordsSearch
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.keywordsSearch.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.sharer_mobile),
      callback: function($$v) {
        _vm.sharer_mobile = $$v
      },
      expression: "sharer_mobile"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.keywordsSearch
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "md": 12,
      "lg": 12
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始时间",
      "end-placeholder": "结束时间",
      "picker-options": _vm.pickerOptions,
      "format": "yyyy-MM-dd HH:mm:ss",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "default-time": ['00:00:00', '23:59:59'],
      "size": "mini"
    },
    on: {
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.created),
      callback: function($$v) {
        _vm.created = $$v
      },
      expression: "created"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": _vm.exportViewOpen2
    }
  }, [_vm._v("以结算时间为准导出")]), _vm._v(" "), (_vm.exportLoading == false) ? _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.exportLoading),
      expression: "exportLoading"
    }],
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": _vm.exportViewOpen
    }
  }, [_vm._v("导出")]) : _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.exportLoading),
      expression: "exportLoading"
    }],
    attrs: {
      "size": "mini",
      "type": "primary",
      "element-loading-text": "拼命导出中..."
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('el-popover', {
    attrs: {
      "placement": "top-start",
      "width": "200",
      "trigger": "hover",
      "content": "导出任务会以队列执行，点击导出后，请至‘设置-导出列表-优选订单’页面中查看及下载数据"
    }
  }, [_c('i', {
    staticClass: "el-icon-question",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "报表下载",
      "visible": _vm.downloadView,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.downloadView = $event
      }
    }
  }, [(_vm.downloadUrl) ? [_c('a', {
    attrs: {
      "href": _vm.downloadUrl,
      "download": ""
    }
  }, [_vm._v(_vm._s(_vm.downloadName))])] : _vm._e()], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "报表设置",
      "visible": _vm.exportView,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.exportView = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label-width": "100px",
      "label": "报表名称"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "报表名称"
    },
    model: {
      value: (_vm.exportTitle),
      callback: function($$v) {
        _vm.exportTitle = $$v
      },
      expression: "exportTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "content-center"
  }, [(_vm.exportLoading == false) ? _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.exportLoading),
      expression: "exportLoading"
    }],
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出报表")]) : _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.exportLoading),
      expression: "exportLoading"
    }],
    attrs: {
      "size": "mini",
      "type": "primary",
      "element-loading-text": "拼命导出中..."
    }
  }, [_vm._v("导出报表")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "recharge-overview view-flex content-center content-padded",
    staticStyle: {
      "width": "40%"
    }
  }, [_c('div', {
    staticClass: "view-flex-item"
  }, [_c('i', {
    staticClass: "iconfont icon-donate"
  }), _vm._v(" "), _c('div', [_c('span', [_vm._v("订单金额")]), _vm._v(" "), _c('span', {
    staticClass: "money mark"
  }, [_vm._v(_vm._s(_vm.orderTongji.yborderPrice))])])]), _vm._v(" "), _c('div', {
    staticClass: "view-flex-item"
  }, [_c('i', {
    staticClass: "iconfont icon-clipboard-list"
  }), _vm._v(" "), _c('div', [_vm._v("订单数 "), _c('span', {
    staticClass: "money mark"
  }, [_vm._v(_vm._s(_vm.orderTongji.yborderCount))])])]), _vm._v(" "), _c('div', {
    staticClass: "view-flex-item"
  }, [_c('i', {
    staticClass: "iconfont icon-dolly-flatbed"
  }), _vm._v(" "), _c('div', [_c('span', [_vm._v("销售数")]), _vm._v(" "), _c('span', {
    staticClass: "money mark"
  }, [_vm._v(_vm._s(_vm.orderTongji.goodsNum))])])])]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.ybordersData,
      "height": _vm.wheight - 210
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "order_id",
      "label": "订单号",
      "width": "170"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bn",
      "label": "商品货号",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "商品名称",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nums",
      "label": "数量",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "nums",
      "label": "自定义佣金",
      "width": "70"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.is_rate_custom == 1) ? _c('el-tag', [_vm._v("否")]) : _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("是")])]
      }
    }], null, false, 2080343296)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pcate_name",
      "label": "推类名称",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pcate_ratio",
      "label": "推类佣金比例",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "count_rate",
      "label": "最终佣金比例",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "实际销售单价",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount",
      "label": "总金额",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_commission",
      "label": "佣金",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "order_status",
      "label": "订单状态",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.order_status == '100') ? _c('el-tag', [_vm._v("已支付")]) : (scope.row.order_status == '105') ? _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("退款中")]) : (scope.row.order_status == '110') ? _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("已退款")]) : (scope.row.order_status == '120') ? _c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("已支付已发货")]) : (scope.row.order_status == '130') ? _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("已支付已退货")]) : (scope.row.order_status == '140') ? _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("已退货已退款")]) : (scope.row.order_status == '150') ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("已成交")]) : (scope.row.order_status == '160') ? _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("已作废")]) : (scope.row.order_status == '170') ? _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("已分佣")]) : (scope.row.order_status == '180') ? _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("分佣已停止")]) : _vm._e()]
      }
    }], null, false, 3384259910)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "billing_status",
      "label": "结算状态",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.billing_status == '1') ? _c('el-tag', [_vm._v("已结算")]) : (scope.row.billing_status == '2') ? _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("结算失败")]) : _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("未结算")])]
      }
    }], null, false, 2456461999)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "member_id",
      "label": "购买者B2C会员ID",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mobile",
      "label": "购买者账号",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user_id",
      "label": "推广者怡贝会员ID",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sharer_mobile",
      "label": "推广者账号",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sharer_name",
      "label": "推广者姓名",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "store_name",
      "label": "店铺名称",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "number",
      "label": "英克ID",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "send_type",
      "label": "配送类型",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "is_fb",
      "label": "佣金翻倍",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.is_fb == 'true') ? _c('el-tag', [_vm._v("是")]) : _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("否")])]
      }
    }], null, false, 1809106893)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "yb_createtime_date",
      "label": "下单时间",
      "width": "170"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "updated_date",
      "label": "更新时间",
      "width": "170"
    }
  })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-padded tc"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next, total",
      "current-page": _vm.params.page,
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-55f769f6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55f769f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/sharer/yborders/list.vue
// module id = 2726
// module chunks = 0